/* eslint-disable import/default */
import Vue from 'vue';
import smoothscroll from 'smoothscroll-polyfill';
import { sync } from 'vuex-router-sync';
import VueAnalytics from 'vue-analytics';
import BrowserDetect from 'vue-browser-detect-plugin';
import Clamp from '@sparing-software/v-clamp';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
import lodash from 'lodash';

import config from 'config';
import { registerGlobalModules } from 'components';
import App from 'components/App';
import router from 'root/router';
import store from 'root/store';

const scrollOptions = {
  container: 'body',
  duration: 1000,
  easing: '[0.25, 0.1, 0.25, 1]',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
};

const analyticsOptions = {
  id: config.analytics,
  router,
};

smoothscroll.polyfill();

Vue.use(Clamp);
Vue.use(VueAnalytics, analyticsOptions);
Vue.use(Vuelidate);
Vue.use(VueScrollTo, scrollOptions);
Vue.use(lodash);
Vue.use(BrowserDetect);

registerGlobalModules();

const unsync = sync(store, router); // eslint-disable-line no-unused-vars

const app = new Vue({
  router,
  store,
  ...App,
  
});

export { app, router, store };
/* eslint-enable import/default */



// WEBPACK FOOTER //
// ./client/app.js